import { Color } from '@videosmart/player-template';

export const colorToRgbaString = (color: Color): string => {
  return `rgba(${color.red},${color.green},${color.blue},${color.alpha})`;
}